import { Notepad } from 'assets/icons/revamp';
import Card from 'components/ui/Card';
import Textarea from 'components/ui/Textarea';
import COLOR from 'constants/color';
import { t } from 'services/i18n.service';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { updateMoreOptionTextInstructions } from 'store/reducer/modal/slice';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';

const Instructions = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);
  return (
    <Card className='flex flex-col ~gap-3/4'>
      <div className='flex items-start ~gap-2/3'>
        <Notepad
          className='~w-4/5 ~h-4/5 flex-shrink-0 mt-0.5'
          fill={COLOR.PRIMARY.LIGHT_900}
          fillDarkMode={COLOR.PRIMARY.LIGHT_900}
        />
        <div className='flex-1 flex flex-col'>
          <h3 className='~text-xs/sm font-semibold text-black dark:text-white'>
            {t('tabs_revamp.instructions_tab.add_instruction')}
          </h3>
          <p className='~text-[0.625rem]/xs text-gray-500 dark:text-gray-400 font-normal'>
            {t('tabs_revamp.instructions_tab.add_instruction_description')}
          </p>
        </div>
      </div>
      <div className='~ml-0/0'>
        <Textarea
          placeholder={t('tabs_revamp.instructions_tab.enter_instructions')}
          value={activity?.text_instructions || ''}
          onChange={(e) =>
            dispatch(updateMoreOptionTextInstructions(e.target.value))
          }
          size='md'
          resize='none'
        />
      </div>
    </Card>
  );
};

export default Instructions;
